export const SignInImage = (props: any) => {
  const { style = {} } = props;
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 420 356"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.691 112.973C342.451 112.799 341.883 112.737 341.62 112.685C340.521 112.468 339.39 112.374 338.27 112.374C334.818 112.379 331.31 112.718 327.916 113.306C325.76 113.679 323.154 114.934 321.01 114.252C317.275 113.065 313.5 113.123 309.956 114.819C306.716 116.369 304.257 119.313 302.821 122.495C302.604 122.976 301.726 124.743 301.477 125.935C301.371 126.179 301.269 126.424 301.177 126.673C300.916 127.38 300.681 128.099 300.463 128.82C300.37 129.127 300.136 129.806 300.414 129.937C299.97 130.759 299.576 131.604 299.249 132.478C298.295 135.018 297.252 137.805 296.917 140.498C296.793 141.495 296.788 142.498 296.904 143.496C296.961 143.99 296.937 144.983 297.271 145.359C297.98 146.155 298.344 145.04 298.264 144.509C297.654 140.46 298.833 136.659 300.23 132.853C301.134 130.393 302.618 128.141 304.281 126.103C305.627 124.452 307.07 123.153 308.915 122.059C311.171 120.72 313.583 119.639 315.972 118.554C317.544 117.84 319.118 117.145 320.733 116.53C321.093 116.393 321.657 116.042 322.056 116.041C322.898 116.038 324.092 116.661 324.906 116.892C327.582 117.654 330.292 118.63 333.058 119.02C334.832 119.269 336.494 118.988 338.153 118.396C338.323 118.336 338.607 118.18 338.956 117.958C340.187 117.484 341.353 116.886 342.367 116.024C342.951 115.528 343.482 114.886 343.966 114.298C344.11 114.123 344.175 113.922 344.177 113.73C344.286 113.673 344.359 113.606 344.376 113.528C344.496 112.95 343.396 112.939 342.691 112.973Z"
        fill="#89C5CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.2635 161.162C61.5864 161.712 60.9223 162.273 60.2744 162.857C59.7803 163.302 58.9062 163.834 58.729 164.508C58.5446 165.209 59.1266 165.865 59.586 166.288C62.0167 168.529 64.7539 170.043 68.122 170.295C73.3083 170.683 77.8219 169.356 82.3217 166.746C85.4824 164.912 87.5762 162.2 88.0334 158.537C91.7977 160.104 95.4382 162.265 98.5321 164.916C100.059 166.224 101.373 167.673 102.589 169.279C103.368 170.309 104.122 171.354 104.821 172.44C105.125 172.912 105.434 173.749 105.935 174.02C106.525 174.339 107.237 173.839 107.208 173.183C107.183 172.637 106.595 172.004 106.319 171.557C105.862 170.816 105.398 170.079 104.91 169.359C104.119 168.192 103.302 167.041 102.411 165.949C100.408 163.495 97.8594 161.468 95.2178 159.739C90.15 156.423 84.5882 154.334 78.4219 154.157C74.6302 154.048 71.4407 155.345 68.1983 157.283C66.1795 158.49 64.0957 159.676 62.2635 161.162Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M338.542 129.302C337.012 128.967 335.322 128.992 333.763 129.02C325.402 129.134 317.191 133.099 311.848 139.436C307.298 144.83 306.047 151.536 305.149 158.315C305.06 158.988 305.022 159.657 304.971 160.332C304.961 160.476 304.944 160.605 304.927 160.727C304.574 161.044 304.388 161.413 304.598 161.818C303.819 163.525 303.16 165.275 302.595 167.08C300.932 172.393 299.24 177.807 300.282 183.394C300.525 180.319 301.038 177.176 301.65 174.151C301.685 173.978 301.724 173.806 301.763 173.634C301.768 173.616 301.771 173.598 301.775 173.58C301.992 172.654 302.274 171.756 302.617 170.871C302.62 170.862 302.624 170.852 302.627 170.843C302.673 170.726 302.721 170.61 302.768 170.495C302.866 170.255 302.967 170.016 303.074 169.778C303.111 169.697 303.145 169.615 303.179 169.533C303.678 168.308 303.888 166.927 304.336 165.659C304.442 165.371 304.554 165.084 304.671 164.798C304.678 164.781 304.685 164.765 304.692 164.748C305.009 163.979 305.359 163.22 305.729 162.468C305.93 162.317 306.037 161.941 306.211 161.6C306.246 161.533 306.527 161.085 306.61 160.826C306.828 160.404 307.045 159.982 307.264 159.56C307.258 159.563 307.251 159.565 307.245 159.568C307.464 159.163 307.684 158.76 307.903 158.359C307.951 158.271 307.999 158.183 308.048 158.094C308.126 157.953 308.205 157.813 308.283 157.672C309.015 156.36 309.792 155.073 310.598 153.802C310.886 153.349 311.574 152.698 311.706 152.19C311.711 152.17 311.712 152.153 311.715 152.135C313.465 149.672 315.479 147.402 317.895 145.602C317.603 145.919 316.982 146.992 316.818 147.204C316.316 147.855 315.771 148.46 315.224 149.073C314.243 150.171 313.287 151.304 312.436 152.502C310.881 154.693 309.54 156.998 308.271 159.35C308.26 159.364 308.246 159.377 308.235 159.391C307.597 160.178 307.196 161.368 306.738 162.268C308.553 161.426 310.561 160.877 312.424 160.129C314.283 159.383 316.09 158.553 317.836 157.578C320.155 156.281 322.562 154.818 324.753 153.162C327.265 151.602 329.375 149.453 331.238 147.199C333.443 144.532 335.463 141.842 336.712 138.603C337.326 137.012 337.809 135.352 338.095 133.673C338.107 133.601 338.123 133.521 338.141 133.439C338.434 132.859 338.695 132.266 338.915 131.66C339.264 130.698 340.088 129.64 338.542 129.302Z"
        fill="#69A1AC"
      />
      <path
        d="M153.978 39.7882H70.914C68.9314 39.7882 67.3242 41.3982 67.3242 43.3842V194.298C67.3242 196.284 68.9314 197.894 70.914 197.894H153.978C155.961 197.894 157.568 196.284 157.568 194.298V43.3842C157.568 41.3982 155.961 39.7882 153.978 39.7882Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.346 186.54C134.063 186.54 137.077 183.522 137.077 179.798C137.077 176.074 134.063 173.056 130.346 173.056C126.629 173.056 123.615 176.074 123.615 179.798C123.615 183.522 126.629 186.54 130.346 186.54Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.784 50.2589C105.411 50.2589 105.919 49.7901 105.919 49.2116C105.919 48.6336 105.411 48.1647 104.784 48.1647C104.157 48.1647 103.649 48.6336 103.649 49.2116C103.649 49.7901 104.157 50.2589 104.784 50.2589Z"
        fill="white"
      />
      <path
        d="M119.778 48.1647H109.654C109.158 48.1647 108.757 48.5672 108.757 49.0637V49.3599C108.757 49.8564 109.158 50.2589 109.654 50.2589H119.778C120.274 50.2589 120.676 49.8564 120.676 49.3599V49.0637C120.676 48.5672 120.274 48.1647 119.778 48.1647Z"
        fill="white"
      />
      <path
        d="M202.141 46.7475H58.9999C58.0087 46.7475 57.2051 47.5525 57.2051 48.5454V119.566C57.2051 120.559 58.0087 121.364 58.9999 121.364H202.141C203.132 121.364 203.936 120.559 203.936 119.566V48.5454C203.936 47.5525 203.132 46.7475 202.141 46.7475Z"
        fill="white"
      />
      <path
        d="M137.492 62.9284H98.7514C98.008 62.9284 97.4053 63.5321 97.4053 64.2769V65.8205C97.4053 66.5652 98.008 67.169 98.7514 67.169H137.492C138.235 67.169 138.838 66.5652 138.838 65.8205V64.2769C138.838 63.5321 138.235 62.9284 137.492 62.9284Z"
        fill="#DDE3E9"
      />
      <path
        d="M123.87 69.9958H98.7514C98.008 69.9958 97.4053 70.5995 97.4053 71.3443V72.8879C97.4053 73.6327 98.008 74.2364 98.7514 74.2364H123.87C124.613 74.2364 125.216 73.6327 125.216 72.8879V71.3443C125.216 70.5995 124.613 69.9958 123.87 69.9958Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.6281 89.4495C69.6018 89.4495 72.0128 87.0344 72.0128 84.0556C72.0128 81.0768 69.6018 78.6616 66.6281 78.6616C63.6545 78.6616 61.2435 81.0768 61.2435 84.0556C61.2435 87.0344 63.6545 89.4495 66.6281 89.4495Z"
        fill="#C5CFD6"
      />
      <path
        d="M202.141 74.6161H58.9999C58.0087 74.6161 57.2051 75.4211 57.2051 76.4141V142.04C57.2051 143.033 58.0087 143.838 58.9999 143.838H202.141C203.132 143.838 203.936 143.033 203.936 142.04V76.4141C203.936 75.4211 203.132 74.6161 202.141 74.6161Z"
        fill="white"
      />
      <path
        d="M137.492 93.5021H98.7514C98.008 93.5021 97.4053 94.1059 97.4053 94.8506V95.4519C97.4053 96.1966 98.008 96.8004 98.7514 96.8004H137.492C138.235 96.8004 138.838 96.1966 138.838 95.4519V94.8506C138.838 94.1059 138.235 93.5021 137.492 93.5021Z"
        fill="#DDE3E9"
      />
      <path
        d="M123.87 98.9995H98.7514C98.008 98.9995 97.4053 99.6032 97.4053 100.348V100.949C97.4053 101.694 98.008 102.298 98.7514 102.298H123.87C124.613 102.298 125.216 101.694 125.216 100.949V100.348C125.216 99.6032 124.613 98.9995 123.87 98.9995Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.6281 114.621C69.6018 114.621 72.0128 112.206 72.0128 109.227C72.0128 106.248 69.6018 103.833 66.6281 103.833C63.6545 103.833 61.2435 106.248 61.2435 109.227C61.2435 112.206 63.6545 114.621 66.6281 114.621Z"
        fill="#C5CFD6"
      />
      <path
        d="M202.141 97.0909H58.9999C58.0087 97.0909 57.2051 97.8959 57.2051 98.8889V164.515C57.2051 165.508 58.0087 166.313 58.9999 166.313H202.141C203.132 166.313 203.936 165.508 203.936 164.515V98.8889C203.936 97.8959 203.132 97.0909 202.141 97.0909Z"
        fill="white"
      />
      <path
        d="M137.492 119.679H98.7514C98.008 119.679 97.4053 120.283 97.4053 121.027V121.629C97.4053 122.373 98.008 122.977 98.7514 122.977H137.492C138.235 122.977 138.838 122.373 138.838 121.629V121.027C138.838 120.283 138.235 119.679 137.492 119.679Z"
        fill="#DDE3E9"
      />
      <path
        d="M123.87 125.176H98.7514C98.008 125.176 97.4053 125.78 97.4053 126.524V127.126C97.4053 127.87 98.008 128.474 98.7514 128.474H123.87C124.613 128.474 125.216 127.87 125.216 127.126V126.524C125.216 125.78 124.613 125.176 123.87 125.176Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.6281 137.096C69.6018 137.096 72.0128 134.681 72.0128 131.702C72.0128 128.723 69.6018 126.308 66.6281 126.308C63.6545 126.308 61.2435 128.723 61.2435 131.702C61.2435 134.681 63.6545 137.096 66.6281 137.096Z"
        fill="#AFB9C5"
      />
      <path
        d="M202.141 119.566H58.9999C58.0087 119.566 57.2051 120.371 57.2051 121.364V186.99C57.2051 187.983 58.0087 188.788 58.9999 188.788H202.141C203.132 188.788 203.936 187.983 203.936 186.99V121.364C203.936 120.371 203.132 119.566 202.141 119.566Z"
        fill="white"
      />
      <path
        d="M137.492 145.855H98.7514C98.008 145.855 97.4053 146.459 97.4053 147.204V147.805C97.4053 148.55 98.008 149.154 98.7514 149.154H137.492C138.235 149.154 138.838 148.55 138.838 147.805V147.204C138.838 146.459 138.235 145.855 137.492 145.855Z"
        fill="#DDE3E9"
      />
      <path
        d="M123.87 151.352H98.7514C98.008 151.352 97.4053 151.956 97.4053 152.701V153.302C97.4053 154.047 98.008 154.65 98.7514 154.65H123.87C124.613 154.65 125.216 154.047 125.216 153.302V152.701C125.216 151.956 124.613 151.352 123.87 151.352Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.6281 159.571C69.6018 159.571 72.0128 157.156 72.0128 154.177C72.0128 151.198 69.6018 148.783 66.6281 148.783C63.6545 148.783 61.2435 151.198 61.2435 154.177C61.2435 157.156 63.6545 159.571 66.6281 159.571Z"
        fill="#C5CFD6"
      />
      <path
        d="M344.833 57.0859H113.744C111.761 57.0859 110.154 58.6958 110.154 60.6818V259.359C110.154 261.345 111.761 262.955 113.744 262.955H344.833C346.816 262.955 348.423 261.345 348.423 259.359V60.6818C348.423 58.6958 346.816 57.0859 344.833 57.0859Z"
        fill="#F2F2F2"
      />
      <path
        d="M319.708 89H287.157C285.175 89 283.568 90.61 283.568 92.596V127.81C283.568 129.796 285.175 131.406 287.157 131.406H319.708C321.69 131.406 323.297 129.796 323.297 127.81V92.596C323.297 90.61 321.69 89 319.708 89Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M303.432 113.606C308.448 113.606 312.514 109.856 312.514 105.229C312.514 100.603 308.448 96.8531 303.432 96.8531C298.417 96.8531 294.351 100.603 294.351 105.229C294.351 109.856 298.417 113.606 303.432 113.606Z"
        fill="#DDE3E9"
      />
      <path
        d="M316.054 115.7H290.811C289.945 115.7 289.244 116.403 289.244 117.271C289.244 118.138 289.945 118.841 290.811 118.841H316.054C316.92 118.841 317.622 118.138 317.622 117.271C317.622 116.403 316.92 115.7 316.054 115.7Z"
        fill="#DDE3E9"
      />
      <path
        d="M311.513 120.935H295.352C294.486 120.935 293.784 121.638 293.784 122.506C293.784 123.373 294.486 124.076 295.352 124.076H311.513C312.379 124.076 313.081 123.373 313.081 122.506C313.081 121.638 312.379 120.935 311.513 120.935Z"
        fill="#DDE3E9"
      />
      <path
        d="M110.154 70.0843C110.154 68.098 111.761 66.4884 113.744 66.4884H344.833C346.816 66.4884 348.423 68.098 348.423 70.0843V80.6237H110.154V70.0843Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.622 75.9116C150.875 75.9116 151.892 74.9744 151.892 73.8179C151.892 72.6613 150.875 71.7237 149.622 71.7237C148.368 71.7237 147.351 72.6613 147.351 73.8179C147.351 74.9744 148.368 75.9116 149.622 75.9116Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.432 75.9116C157.686 75.9116 158.703 74.9744 158.703 73.8179C158.703 72.6613 157.686 71.7237 156.432 71.7237C155.179 71.7237 154.162 72.6613 154.162 73.8179C154.162 74.9744 155.179 75.9116 156.432 75.9116Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M163.243 75.9116C164.497 75.9116 165.513 74.9744 165.513 73.8179C165.513 72.6613 164.497 71.7237 163.243 71.7237C161.989 71.7237 160.973 72.6613 160.973 73.8179C160.973 74.9744 161.989 75.9116 163.243 75.9116Z"
        fill="#F2F2F2"
      />
      <path
        d="M319.708 135.594H287.157C285.175 135.594 283.568 137.204 283.568 139.19V233.563C283.568 235.549 285.175 237.159 287.157 237.159H319.708C321.69 237.159 323.297 235.549 323.297 233.563V139.19C323.297 137.204 321.69 135.594 319.708 135.594Z"
        fill="white"
      />
      <path
        d="M311.286 145.018H295.579C294.587 145.018 293.784 145.823 293.784 146.816V156.832C293.784 157.825 294.587 158.63 295.579 158.63H311.286C312.277 158.63 313.081 157.825 313.081 156.832V146.816C313.081 145.823 312.277 145.018 311.286 145.018Z"
        fill="#DDE3E9"
      />
      <path
        d="M311.286 162.818H295.579C294.587 162.818 293.784 163.623 293.784 164.616V174.108C293.784 175.101 294.587 175.906 295.579 175.906H311.286C312.277 175.906 313.081 175.101 313.081 174.108V164.616C313.081 163.623 312.277 162.818 311.286 162.818Z"
        fill="#AFB9C5"
      />
      <path
        d="M311.286 180.094H295.579C294.587 180.094 293.784 180.899 293.784 181.892V191.384C293.784 192.377 294.587 193.182 295.579 193.182H311.286C312.277 193.182 313.081 192.377 313.081 191.384V181.892C313.081 180.899 312.277 180.094 311.286 180.094Z"
        fill="#DDE3E9"
      />
      <path
        d="M311.286 214.647H295.579C294.587 214.647 293.784 215.452 293.784 216.445V225.937C293.784 226.93 294.587 227.735 295.579 227.735H311.286C312.277 227.735 313.081 226.93 313.081 225.937V216.445C313.081 215.452 312.277 214.647 311.286 214.647Z"
        fill="#DDE3E9"
      />
      <path
        d="M311.286 197.371H295.579C294.587 197.371 293.784 198.176 293.784 199.169V208.661C293.784 209.654 294.587 210.459 295.579 210.459H311.286C312.277 210.459 313.081 209.654 313.081 208.661V199.169C313.081 198.176 312.277 197.371 311.286 197.371Z"
        fill="#C5CFD6"
      />
      <path
        d="M304.449 76.8636H119.128C118.137 76.8636 117.333 77.6686 117.333 78.6616V146.535C117.333 147.528 118.137 148.333 119.128 148.333H304.449C305.44 148.333 306.244 147.528 306.244 146.535V78.6616C306.244 77.6686 305.44 76.8636 304.449 76.8636Z"
        fill="white"
      />
      <path
        d="M249.87 96.9053H157.779C157.035 96.9053 156.432 97.509 156.432 98.2538V99.2477C156.432 99.9924 157.035 100.596 157.779 100.596H249.87C250.613 100.596 251.216 99.9924 251.216 99.2477V98.2538C251.216 97.509 250.613 96.9053 249.87 96.9053Z"
        fill="#DDE3E9"
      />
      <path
        d="M218.708 103.057H157.779C157.035 103.057 156.432 103.66 156.432 104.405V105.399C156.432 106.144 157.035 106.747 157.779 106.747H218.708C219.452 106.747 220.054 106.144 220.054 105.399V104.405C220.054 103.66 219.452 103.057 218.708 103.057Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 105.491C267.574 105.491 269.352 103.85 269.352 101.826C269.352 99.8027 267.574 98.1616 265.379 98.1616C263.185 98.1616 261.406 99.8027 261.406 101.826C261.406 103.85 263.185 105.491 265.379 105.491Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 103.397C266.32 103.397 267.082 102.694 267.082 101.826C267.082 100.959 266.32 100.256 265.379 100.256C264.439 100.256 263.677 100.959 263.677 101.826C263.677 102.694 264.439 103.397 265.379 103.397Z"
        fill="#F2F2F2"
      />
      <path
        d="M304.449 101.586H119.128C118.137 101.586 117.333 102.391 117.333 103.384V167.662C117.333 168.655 118.137 169.46 119.128 169.46H304.449C305.44 169.46 306.244 168.655 306.244 167.662V103.384C306.244 102.391 305.44 101.586 304.449 101.586Z"
        fill="white"
      />
      <path
        d="M249.87 124.443H157.779C157.035 124.443 156.432 125.047 156.432 125.792V126.157C156.432 126.902 157.035 127.506 157.779 127.506H249.87C250.613 127.506 251.216 126.902 251.216 126.157V125.792C251.216 125.047 250.613 124.443 249.87 124.443Z"
        fill="#DDE3E9"
      />
      <path
        d="M218.708 129.547H157.779C157.035 129.547 156.432 130.151 156.432 130.896V131.261C156.432 132.006 157.035 132.61 157.779 132.61H218.708C219.452 132.61 220.054 132.006 220.054 131.261V130.896C220.054 130.151 219.452 129.547 218.708 129.547Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 132.191C267.574 132.191 269.352 130.55 269.352 128.526C269.352 126.503 267.574 124.862 265.379 124.862C263.185 124.862 261.406 126.503 261.406 128.526C261.406 130.55 263.185 132.191 265.379 132.191Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 130.097C266.32 130.097 267.082 129.394 267.082 128.526C267.082 127.659 266.32 126.956 265.379 126.956C264.439 126.956 263.677 127.659 263.677 128.526C263.677 129.394 264.439 130.097 265.379 130.097Z"
        fill="#F2F2F2"
      />
      <path
        d="M304.449 122.712H119.128C118.137 122.712 117.333 123.517 117.333 124.51V188.788C117.333 189.781 118.137 190.586 119.128 190.586H304.449C305.44 190.586 306.244 189.781 306.244 188.788V124.51C306.244 123.517 305.44 122.712 304.449 122.712Z"
        fill="white"
      />
      <path
        d="M249.87 149.049H157.779C157.035 149.049 156.432 149.653 156.432 150.397V150.763C156.432 151.508 157.035 152.112 157.779 152.112H249.87C250.613 152.112 251.216 151.508 251.216 150.763V150.397C251.216 149.653 250.613 149.049 249.87 149.049Z"
        fill="#DDE3E9"
      />
      <path
        d="M218.708 154.153H157.779C157.035 154.153 156.432 154.757 156.432 155.502V155.868C156.432 156.612 157.035 157.216 157.779 157.216H218.708C219.452 157.216 220.054 156.612 220.054 155.868V155.502C220.054 154.757 219.452 154.153 218.708 154.153Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 156.797C267.574 156.797 269.352 155.156 269.352 153.133C269.352 151.109 267.574 149.468 265.379 149.468C263.185 149.468 261.406 151.109 261.406 153.133C261.406 155.156 263.185 156.797 265.379 156.797Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 154.703C266.32 154.703 267.082 154 267.082 153.132C267.082 152.265 266.32 151.562 265.379 151.562C264.439 151.562 263.677 152.265 263.677 153.132C263.677 154 264.439 154.703 265.379 154.703Z"
        fill="#AFB9C5"
      />
      <path
        d="M304.449 186.091H119.128C118.137 186.091 117.333 186.896 117.333 187.889V252.167C117.333 253.16 118.137 253.965 119.128 253.965H304.449C305.44 253.965 306.244 253.16 306.244 252.167V187.889C306.244 186.896 305.44 186.091 304.449 186.091Z"
        fill="white"
      />
      <path
        d="M249.87 222.866H157.779C157.035 222.866 156.432 223.47 156.432 224.215V224.58C156.432 225.325 157.035 225.929 157.779 225.929H249.87C250.613 225.929 251.216 225.325 251.216 224.58V224.215C251.216 223.47 250.613 222.866 249.87 222.866Z"
        fill="#DDE3E9"
      />
      <path
        d="M218.708 227.971H157.779C157.035 227.971 156.432 228.575 156.432 229.319V229.685C156.432 230.43 157.035 231.033 157.779 231.033H218.708C219.452 231.033 220.054 230.43 220.054 229.685V229.319C220.054 228.575 219.452 227.971 218.708 227.971Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 230.615C267.574 230.615 269.352 228.974 269.352 226.95C269.352 224.926 267.574 223.285 265.379 223.285C263.185 223.285 261.406 224.926 261.406 226.95C261.406 228.974 263.185 230.615 265.379 230.615Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 228.521C266.32 228.521 267.082 227.817 267.082 226.95C267.082 226.082 266.32 225.379 265.379 225.379C264.439 225.379 263.677 226.082 263.677 226.95C263.677 227.817 264.439 228.521 265.379 228.521Z"
        fill="#F2F2F2"
      />
      <path
        d="M304.449 164.965H119.128C118.137 164.965 117.333 165.77 117.333 166.763V231.04C117.333 232.033 118.137 232.838 119.128 232.838H304.449C305.44 232.838 306.244 232.033 306.244 231.04V166.763C306.244 165.77 305.44 164.965 304.449 164.965Z"
        fill="white"
      />
      <path
        d="M249.87 198.261H157.779C157.035 198.261 156.432 198.864 156.432 199.609V199.975C156.432 200.719 157.035 201.323 157.779 201.323H249.87C250.613 201.323 251.216 200.719 251.216 199.975V199.609C251.216 198.864 250.613 198.261 249.87 198.261Z"
        fill="#DDE3E9"
      />
      <path
        d="M218.708 203.365H157.779C157.035 203.365 156.432 203.969 156.432 204.713V205.079C156.432 205.824 157.035 206.428 157.779 206.428H218.708C219.452 206.428 220.054 205.824 220.054 205.079V204.713C220.054 203.969 219.452 203.365 218.708 203.365Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 206.009C267.574 206.009 269.352 204.368 269.352 202.344C269.352 200.32 267.574 198.679 265.379 198.679C263.185 198.679 261.406 200.32 261.406 202.344C261.406 204.368 263.185 206.009 265.379 206.009Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 203.915C266.32 203.915 267.082 203.212 267.082 202.344C267.082 201.477 266.32 200.774 265.379 200.774C264.439 200.774 263.677 201.477 263.677 202.344C263.677 203.212 264.439 203.915 265.379 203.915Z"
        fill="#F2F2F2"
      />
      <path
        d="M304.449 143.838H119.128C118.137 143.838 117.333 144.643 117.333 145.636V209.914C117.333 210.907 118.137 211.712 119.128 211.712H304.449C305.44 211.712 306.244 210.907 306.244 209.914V145.636C306.244 144.643 305.44 143.838 304.449 143.838Z"
        fill="white"
      />
      <path
        d="M249.87 173.655H157.779C157.035 173.655 156.432 174.258 156.432 175.003V175.369C156.432 176.114 157.035 176.717 157.779 176.717H249.87C250.613 176.717 251.216 176.114 251.216 175.369V175.003C251.216 174.258 250.613 173.655 249.87 173.655Z"
        fill="#DDE3E9"
      />
      <path
        d="M218.708 178.759H157.779C157.035 178.759 156.432 179.363 156.432 180.108V180.473C156.432 181.218 157.035 181.822 157.779 181.822H218.708C219.452 181.822 220.054 181.218 220.054 180.473V180.108C220.054 179.363 219.452 178.759 218.708 178.759Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 181.403C267.574 181.403 269.352 179.762 269.352 177.738C269.352 175.714 267.574 174.074 265.379 174.074C263.185 174.074 261.406 175.714 261.406 177.738C261.406 179.762 263.185 181.403 265.379 181.403Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.379 179.309C266.32 179.309 267.082 178.605 267.082 177.738C267.082 176.871 266.32 176.168 265.379 176.168C264.439 176.168 263.677 176.871 263.677 177.738C263.677 178.605 264.439 179.309 265.379 179.309Z"
        fill="#F2F2F2"
      />
      <path
        d="M285.97 43.9765H285.706C284.838 43.9765 284.135 44.6808 284.135 45.5497V55.4915C284.135 56.3603 284.838 57.0647 285.706 57.0647H285.97C286.838 57.0647 287.541 56.3603 287.541 55.4915V45.5497C287.541 44.6808 286.838 43.9765 285.97 43.9765Z"
        fill="#DDE3E9"
      />
      <path
        d="M293.916 35.6H293.652C292.784 35.6 292.081 36.3044 292.081 37.1732V55.4915C292.081 56.3603 292.784 57.0647 293.652 57.0647H293.916C294.783 57.0647 295.487 56.3603 295.487 55.4915V37.1732C295.487 36.3044 294.783 35.6 293.916 35.6Z"
        fill="#DDE3E9"
      />
      <path
        d="M301.862 31.4117H301.598C300.73 31.4117 300.027 32.1161 300.027 32.985V55.4915C300.027 56.3603 300.73 57.0647 301.598 57.0647H301.862C302.729 57.0647 303.432 56.3603 303.432 55.4915V32.985C303.432 32.1161 302.729 31.4117 301.862 31.4117Z"
        fill="#DDE3E9"
      />
      <path
        d="M309.808 35.6H309.543C308.676 35.6 307.973 36.3044 307.973 37.1732V55.4915C307.973 56.3603 308.676 57.0647 309.543 57.0647H309.808C310.675 57.0647 311.378 56.3603 311.378 55.4915V37.1732C311.378 36.3044 310.675 35.6 309.808 35.6Z"
        fill="#DDE3E9"
      />
      <path
        d="M317.754 27.2235H317.489C316.622 27.2235 315.919 27.9279 315.919 28.7968V55.4915C315.919 56.3603 316.622 57.0647 317.489 57.0647H317.754C318.621 57.0647 319.324 56.3603 319.324 55.4915V28.7968C319.324 27.9279 318.621 27.2235 317.754 27.2235Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.718 217.373C52.718 211.541 57.8271 206.768 64.0692 206.768V217.373L56.3118 225.091C54.105 223.204 52.718 220.436 52.718 217.373Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.769 217.238H75.2324C75.2324 219.972 74.0235 222.533 72.1124 224.394C70.0106 226.43 67.0177 227.709 63.769 227.709C60.7765 227.709 58.0375 226.605 55.9348 224.859L63.769 217.238Z"
        fill="#AFB9C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.4209 217.238C75.4209 211.481 70.3114 206.768 64.0692 206.768V217.238H75.4209ZM58.3939 206.768L62.9344 216.191L52.718 212.003C53.7281 209.56 55.9968 207.699 58.3939 206.768Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M374.246 192.229C373.155 193.297 371.61 193.967 369.892 193.967C366.59 193.967 363.913 191.506 363.913 188.471C363.913 185.435 366.59 182.974 369.892 182.974V172.765C360.499 172.765 352.811 179.834 352.811 188.471C352.811 197.107 360.499 204.176 369.892 204.176C374.826 204.176 379.285 202.257 382.324 199.204L374.246 192.229Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M369.838 172.765V182.974C373.129 182.974 375.797 185.435 375.797 188.471H386.865C386.865 179.834 379.201 172.765 369.838 172.765Z"
        fill="#AFB9C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M375.569 188.471C375.569 190.254 374.658 191.84 373.243 192.863L380.203 201.035C384.254 198.11 386.865 193.575 386.865 188.471H375.569Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.002 47.9049C265.163 48.7239 263.975 49.2381 262.653 49.2381C260.113 49.2381 258.054 47.3512 258.054 45.0237C258.054 42.696 260.113 40.8091 262.653 40.8091V32.9824C255.428 32.9824 249.514 38.4021 249.514 45.0237C249.514 51.6452 255.428 57.0647 262.653 57.0647C266.448 57.0647 269.878 55.5931 272.216 53.2526L266.002 47.9049Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M262.568 32.9824V40.8091C265.091 40.8091 267.136 42.696 267.136 45.0237H275.622C275.622 38.4021 269.746 32.9824 262.568 32.9824Z"
        fill="#AFB9C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M267.149 45.0237C267.149 46.3613 266.466 47.5503 265.405 48.318L270.625 54.4469C273.663 52.2529 275.622 48.8516 275.622 45.0237H267.149Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3824 57.0575C59.3801 57.063 59.3779 57.0679 59.3743 57.0742C59.3779 57.0693 59.3824 57.0481 59.3824 57.0575Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3769 57.0659C59.3769 57.0668 59.376 57.0691 59.376 57.071C59.376 57.0659 59.3867 57.0496 59.3769 57.0659Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.4164 56.9771C59.4083 56.9978 59.3984 57.018 59.389 57.0387C59.3939 57.0283 59.3984 57.0198 59.4029 57.0094C59.2849 57.2818 59.3598 57.1047 59.4164 56.9771Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3918 57.04C59.3867 57.0496 59.3822 57.0601 59.3776 57.0697C59.3442 57.1296 59.3918 57.04 59.3918 57.04Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3778 57.0658C59.3778 57.0648 59.3778 57.0648 59.3793 57.0638C59.3778 57.0648 59.3778 57.0648 59.3778 57.0658Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3724 57.0733C59.3656 57.086 59.4044 57.0251 59.3724 57.0733V57.0733Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3773 57.0661L59.3802 57.0638C59.3785 57.065 59.3785 57.0661 59.3773 57.0661Z"
        fill="#C5CFD6"
      />
      <path
        d="M84.2591 29.8412H33.93C32.9387 29.8412 32.1351 30.6461 32.1351 31.6391V61.0255C32.1351 62.0185 32.9387 62.8235 33.93 62.8235H84.2591C85.2504 62.8235 86.054 62.0185 86.054 61.0255V31.6391C86.054 30.6461 85.2504 29.8412 84.2591 29.8412Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.5676 39.2647L36.6758 62.8237H68.4594L52.5676 39.2647Z"
        fill="#AFB9C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.1758 45.5469L54.27 62.8237H82.0811L68.1758 45.5469Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.1353 45.5469C76.9564 45.5469 79.2435 43.4375 79.2435 40.8353C79.2435 38.2331 76.9564 36.1235 74.1353 36.1235C71.3142 36.1235 69.0271 38.2331 69.0271 40.8353C69.0271 43.4375 71.3142 45.5469 74.1353 45.5469Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.104 280.604C330.106 280.61 330.109 280.615 330.112 280.622C330.109 280.616 330.104 280.595 330.104 280.604Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.11 280.613C330.11 280.614 330.111 280.616 330.111 280.618C330.111 280.613 330.1 280.596 330.11 280.613Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.07 280.524C330.078 280.545 330.088 280.565 330.097 280.586C330.093 280.575 330.088 280.567 330.084 280.556C330.202 280.829 330.127 280.652 330.07 280.524Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.096 280.587C330.1 280.596 330.105 280.607 330.109 280.617C330.143 280.676 330.096 280.587 330.096 280.587Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.109 280.614C330.109 280.612 330.109 280.612 330.108 280.611C330.109 280.612 330.109 280.612 330.109 280.614Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.114 280.62C330.121 280.633 330.082 280.572 330.114 280.62V280.62Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.11 280.614L330.107 280.611C330.109 280.612 330.109 280.614 330.11 280.614Z"
        fill="#C5CFD6"
      />
      <path
        d="M291.605 240.3H368.61C369.602 240.3 370.405 241.105 370.405 242.098V287.714C370.405 288.707 369.602 289.512 368.61 289.512H291.605C290.614 289.512 289.811 288.707 289.811 287.714V242.098C289.811 241.105 290.614 240.3 291.605 240.3Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M340.48 254.435L363.781 289.512H317.178L340.48 254.435Z"
        fill="#AFB9C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M316.455 263.831L337.055 289.512H295.855L316.455 263.831Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M307.689 263.859C303.458 263.859 300.027 260.694 300.027 256.791C300.027 252.888 303.458 249.724 307.689 249.724C311.921 249.724 315.351 252.888 315.351 256.791C315.351 260.694 311.921 263.859 307.689 263.859Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.12 175.116C136.384 177.088 139.591 178.041 141.096 177.652C144.871 176.677 145.219 162.833 142.297 157.375C139.377 151.918 124.36 149.538 123.604 160.352C123.341 164.105 124.913 167.454 127.236 170.187L123.071 189.646H135.169L133.12 175.116Z"
        fill="#B28B67"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.737 152.255C143.737 154.953 141.627 157.158 138.97 157.3C137.45 157.77 135.497 158.115 133.332 158.261C133.542 159.054 133.656 159.954 133.656 160.971C133.656 161.87 133.557 162.823 133.375 163.791C132.906 163.231 132.277 162.865 131.64 162.865C129.857 162.865 128.616 164.336 128.616 165.897C128.616 167.879 129.757 169.312 131.423 169.427C129.923 172.313 127.848 174.487 125.775 174.487C121.838 174.487 119.039 169.211 119.039 163.537C119.039 163.338 119.043 163.14 119.05 162.944C117.717 163.86 116.483 165.062 115.238 166.273C112.595 168.845 109.912 171.455 106.165 171.455C98.668 171.455 95.6908 156.297 106.165 156.297C113.289 156.297 116.793 157.338 119.813 158.878C120.408 157.194 121.316 155.779 122.427 154.791C122.694 154.49 123.103 154.201 123.632 153.934C123.955 153.756 124.289 153.612 124.633 153.504C126.454 152.833 129.092 152.359 132.038 152.257C132.589 152.237 133.129 152.231 133.656 152.239C133.665 149.455 135.918 147.201 138.697 147.201C141.481 147.201 143.737 149.464 143.737 152.255Z"
        fill="#272646"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M182.655 269.821C181.717 280.099 182.654 302.191 183.158 308.564C183.476 312.569 188.921 311.521 189.429 308.315C189.515 307.772 189.866 305.865 190.39 303.018C192.957 289.059 199.676 252.527 199.688 243.644C199.693 239.57 190.647 236.313 187.028 241.234C184.052 239.138 179.829 238.577 177.225 242.808C175.254 246.011 170.57 255.105 165.575 265.725C161.199 275.028 154.361 297.611 154.361 297.611L160.166 300.27C160.166 300.27 174.506 277.159 183.534 260.956C183.235 263.744 182.937 266.729 182.655 269.821Z"
        fill="#B28B67"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.776 289.251L174.701 241.937C179.474 234.24 192.856 243.503 191.228 247.967C187.533 258.102 168.738 290.913 167.638 293.932L154.776 289.251Z"
        fill="#CB8D3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M200.192 247.338C200.192 260.749 194.328 292.273 194.324 295.226L180.118 294.746C180.118 294.746 183.843 253.633 183.26 253.355C182.385 252.937 147.398 258.209 136.905 258.607C121.773 259.181 115.514 249.876 115.006 232.217H144.316C144.316 232.217 181.91 236.715 193.733 238.474C198.794 239.227 200.192 243.643 200.192 247.338Z"
        fill="#E49A38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.973 295.845C154.559 295.52 153.953 295.59 153.658 296.026C153.054 296.917 152.152 298.346 151.937 299.209C151.607 300.536 151.415 303.19 151.415 303.19C152.95 303.574 179.001 310.085 179.001 310.085C179.001 310.085 180.962 306.79 178.717 305.927C176.47 305.064 174.995 304.452 174.995 304.452L163.554 295.482C163.355 295.326 163.066 295.366 162.916 295.57L161.56 297.414C161.56 297.414 159.166 297.881 157.825 297.546C156.975 297.333 155.753 296.458 154.973 295.845Z"
        fill="#E4E4E4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.675 300.398C183.195 300.184 182.624 300.398 182.443 300.893C182.073 301.904 181.542 303.509 181.542 304.399C181.542 305.766 181.996 308.388 181.996 308.388C183.578 308.388 210.426 308.388 210.426 308.388C210.426 308.388 211.534 304.716 209.146 304.423C206.759 304.13 205.18 303.894 205.18 303.894L191.914 297.966C191.683 297.862 191.413 297.971 191.316 298.205L190.445 300.323C190.445 300.323 188.235 301.357 186.853 301.357C185.977 301.357 184.58 300.804 183.675 300.398Z"
        fill="#E4E4E4"
      />
      <path
        d="M206.996 308.388H183.812C182.837 308.388 182.046 309.18 182.046 310.157C182.046 311.133 182.837 311.925 183.812 311.925H206.996C207.971 311.925 208.761 311.133 208.761 310.157C208.761 309.18 207.971 308.388 206.996 308.388Z"
        fill="#2F3676"
      />
      <path
        d="M108.453 239.617C108.453 237.134 110.462 235.122 112.94 235.122H167.982C170.46 235.122 172.469 237.134 172.469 239.617V264.934H110.248C109.257 264.934 108.453 264.129 108.453 263.136V239.617Z"
        fill="#383838"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.428 235.122H169.004C171.201 235.122 173.076 236.716 173.432 238.889L184.566 306.872H179.18"
        fill="#383838"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M182.046 316.978C187.057 316.978 191.119 312.906 191.119 307.883C191.119 302.86 187.057 298.788 182.046 298.788C177.035 298.788 172.973 302.86 172.973 307.883C172.973 312.906 177.035 316.978 182.046 316.978Z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.315 277.566C153.315 298.774 136.163 315.968 115.006 315.968C93.8488 315.968 76.6975 298.774 76.6975 277.566C76.6975 256.357 93.8488 239.164 115.006 239.164C136.163 239.164 153.315 256.357 153.315 277.566ZM146.258 277.566C146.258 294.868 132.266 308.893 115.006 308.893C97.7464 308.893 83.7545 294.868 83.7545 277.566C83.7545 260.264 97.7464 246.238 115.006 246.238C132.266 246.238 146.258 260.264 146.258 277.566Z"
        fill="#191847"
      />
      <path d="M117.022 244.217H112.99V310.915H117.022V244.217Z" fill="#191847" />
      <path
        d="M139.321 254.778L137.739 253.191C137.388 252.84 136.82 252.84 136.47 253.191L90.6906 299.082C90.3403 299.433 90.3403 300.003 90.6906 300.354L92.2733 301.94C92.6236 302.292 93.1917 302.292 93.542 301.94L139.321 256.05C139.672 255.699 139.672 255.129 139.321 254.778Z"
        fill="#191847"
      />
      <path
        d="M148.274 278.688V276.443C148.274 275.947 147.872 275.544 147.376 275.544H82.6353C82.1397 275.544 81.7379 275.947 81.7379 276.443V278.688C81.7379 279.184 82.1397 279.587 82.6353 279.587H147.376C147.872 279.587 148.274 279.184 148.274 278.688Z"
        fill="#191847"
      />
      <path
        d="M137.739 301.94L139.321 300.354C139.672 300.003 139.672 299.433 139.321 299.082L93.5422 253.191C93.1918 252.84 92.6238 252.84 92.2735 253.191L90.6908 254.778C90.3404 255.129 90.3404 255.698 90.6908 256.05L136.47 301.94C136.82 302.291 137.388 302.291 137.739 301.94Z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.5076 254.276C91.9848 251.272 99.3648 212.611 99.3648 212.611L110.402 212.652C110.402 212.652 97.7925 253.606 97.0149 255.538C96.0048 258.047 97.7207 261.693 98.8843 264.165C99.0642 264.548 99.2311 264.902 99.3725 265.22C97.758 265.944 96.9826 265.069 96.165 264.146C95.2416 263.104 94.2643 262.001 91.9641 263.074C91.0757 263.488 90.2348 263.979 89.4132 264.457C86.5755 266.11 83.9684 267.63 80.4218 265.436C79.8595 265.088 79.2434 263.779 80.7323 262.755C84.4409 260.206 89.7856 255.745 90.5076 254.276ZM183.468 239.212L169.189 225.249L164.446 233.474L179.295 242.25C183.018 248.129 185.204 250.669 185.854 249.871C186.403 249.197 186.151 248.459 185.92 247.78C185.74 247.25 185.572 246.756 185.802 246.355C186.33 245.44 189.311 245.964 192.119 246.583C194.927 247.201 194.277 245.818 193.68 245.097C191.027 242.95 187.623 240.989 183.468 239.212Z"
        fill="#B28B67"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.999 181.224L137.357 180.474C144.223 204.805 179.502 221.389 181.667 230.485C182.462 233.821 180.067 235.507 181.304 236.522L175.638 240.68C174.679 239.558 172.632 241.61 168.356 240.175C164.081 238.739 132.999 210.033 132.999 181.224Z"
        fill="#D04C4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M125.025 176.129C124.037 176.059 123.179 176.806 123.11 177.797L122.888 180.979C114.685 187.307 94.3544 206.216 89.0564 241.416C88.5 245.114 89.5065 247.094 90.3106 248.676C90.8607 249.759 91.3162 250.655 91.112 251.787L98.5262 253.839C98.5262 253.003 99.4608 252.367 100.667 251.547C102.419 250.354 104.746 248.771 105.606 245.615C106.421 242.624 107.615 238.888 109.041 234.732C109.176 240.236 110.218 245.298 112.486 249.491C118.145 259.951 150.849 248.48 154.266 237.809C156.089 232.115 153.502 227.334 150.08 221.012C145.737 212.986 140.049 202.476 140.33 184.458L140.709 179.03C140.778 178.04 140.033 177.181 139.044 177.111L125.025 176.129Z"
        fill="#F54D4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.485 138.737C278.216 140.71 275.004 141.664 273.496 141.274C269.715 140.299 269.368 126.444 272.293 120.982C275.218 115.52 290.257 113.139 291.014 123.961C291.277 127.717 289.703 131.069 287.377 133.804L291.548 153.278H279.433L281.485 138.737Z"
        fill="#DAA574"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M280.879 125.156C279.831 123.593 278.825 122.401 277.516 121.708C272.19 121.793 271.566 120.836 271.566 117.613C272.426 116.996 275.462 115.958 278.861 115.665C280.595 115.168 282.65 115.262 284.628 116.091C287.071 116.786 289.14 118.281 290.053 121.08C293.359 126.795 290.85 132.744 287.469 134.776C286.569 133.707 285.783 132.672 285.083 131.681C285.646 131.13 285.995 130.361 285.995 129.511C285.995 127.835 284.639 126.477 282.966 126.477C282.843 126.477 282.722 126.484 282.603 126.498C282.527 128.593 282.218 135.681 281.404 138.143C280.445 141.046 274.847 141.759 272.895 141.759C271.209 141.759 271.266 140.159 271.307 139.013C271.313 138.848 271.318 138.692 271.318 138.552C271.318 138.259 271.699 138.26 272.128 138.261C272.687 138.262 273.327 138.263 273.327 137.622C273.327 136.923 272.364 136.387 271.501 135.907C270.962 135.608 270.463 135.33 270.263 135.049C269.63 134.162 269.417 132.965 270.372 132.965C270.894 132.965 271.609 133.266 272.471 133.629C273.771 134.176 275.403 134.863 277.198 134.863C280.165 134.863 280.87 125.276 280.879 125.156Z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M299.608 195.98L281.334 260.346L268.001 307.788H258.276L272.444 195.98H299.608Z"
        fill="#6EAB4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M304.496 195.98C304.919 229.155 306.36 247.25 306.804 250.263C307.247 253.278 313.958 272.452 326.935 307.788H316.861C300.34 273.889 291.117 254.715 289.193 250.263C287.27 245.813 281.332 227.718 272.389 195.98H304.496Z"
        fill="#74C248"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M327.836 316.894L327.332 306.27H316.747C309.218 311.582 297.088 314.87 297.088 314.87V316.894H316.242L322.795 315.882V316.894H327.836Z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.365 316.894L268.861 306.27H258.276C250.747 311.582 238.617 314.87 238.617 314.87V316.894H257.772L264.324 315.882V316.894H269.365Z"
        fill="#191847"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242.069 207.415L256.372 193.461L261.119 201.678L246.247 210.449C242.518 216.323 240.327 218.861 239.676 218.064C239.127 217.391 239.379 216.654 239.611 215.975C239.792 215.445 239.96 214.952 239.729 214.551C239.201 213.637 236.215 214.161 233.403 214.78C230.591 215.399 231.242 214.018 231.84 213.297C234.498 211.151 237.907 209.19 242.069 207.415ZM328.586 216.273C326.705 213.507 317.652 185.246 317.652 185.246L307.212 186.758C307.212 186.758 321.269 216.628 322.308 218.43C323.658 220.771 322.463 224.618 321.652 227.226C321.526 227.63 321.41 228.003 321.314 228.337C323.015 228.828 323.663 227.854 324.346 226.827C325.117 225.667 325.933 224.44 328.363 225.18C329.301 225.466 330.203 225.833 331.085 226.192C334.129 227.431 336.925 228.57 340.138 225.905C340.647 225.482 341.076 224.101 339.458 223.297C335.426 221.293 329.507 217.625 328.586 216.273Z"
        fill="#DAA574"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.815 145.593L277.389 145.46C263.294 161.572 260.441 189.115 242.76 205.982L248.314 211.18C281.827 202.157 285.725 168.502 281.815 145.593Z"
        fill="#E3B92D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M308.28 197.26C308.28 197.26 282.282 200.92 270.032 202.644C268.284 202.89 268.26 200.321 268.334 199.012C269.188 183.905 278.347 166.461 275.412 145.541L286.202 142.258C297.386 155.648 303.077 173.272 308.28 197.26Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M314.053 207.152C316.351 211.038 318.542 214.403 320.519 216.946L328.722 215.791C325.601 187.134 311.717 166.699 300.819 154.734C302.806 154.308 304.5 153.213 305.356 150.985C308.367 143.142 306.349 139.341 301.855 138.631C299.384 138.24 297.225 139.048 294.64 140.015C292.525 140.807 290.125 141.705 287.036 142.14C287.035 142.14 287.033 142.141 287.033 142.141C286.733 142.183 286.464 142.241 286.222 142.314L282.59 143.039C282.59 143.039 274.794 195.503 283.822 211.408L314.053 207.152Z"
        fill="#FCCE32"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M314.053 207.152C311.038 202.052 307.838 196.056 304.696 189.84C304.877 197.147 304.51 204.563 302.754 208.742L314.053 207.152Z"
        fill="black"
        fillOpacity="0.1"
      />
    </svg>
  );
};
